export default __webpack_public_path__ + "img/logo-age-mob.png?43ce";